import { isTouchDevice } from '@/utils/device'
import { App } from 'vue'

const Plugin = {
  install (app: App): void {
    app.config.globalProperties.$isTouchDevice = isTouchDevice()
  }
}

export default Plugin
